import { render } from "./HorsesTable.vue?vue&type=template&id=2ff6ea14"
import script from "./HorsesTable.vue?vue&type=script&lang=js"
export * from "./HorsesTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/iomac/Progetti/equiup/equiupmaneggi/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__